import React from "react";
import { FiChevronRight } from "react-icons/fi";
import NewIcon from "../../../assets/img/card-icons/newicon.svg";
import NewCalender from "../../../assets/img/card-icons/newcalender.svg";
import NewWhatsapp from "../../../assets/img/card-icons/newwhatsapp.svg";
import { getTelUrl, getWhatsAppUrl } from "./contactLinks";
import "./AtencionInfoMobile.scss";

const AtencionInfoMobile = ({ atencionTelefonica, centralTurno, whatsapp }) => {
  const cards = [
    {
      icon: NewIcon,
      staticText: "Atención telefónica las 24hs",
      dynamicValue: atencionTelefonica,
      getHref: getTelUrl,
      isExternal: false,
    },
    {
      icon: NewCalender,
      staticText: "Central de turnos",
      dynamicValue: centralTurno,
      getHref: getTelUrl,
      isExternal: false,
    },
    {
      icon: NewWhatsapp,
      staticText: "WhatsApp",
      dynamicValue: whatsapp,
      getHref: getWhatsAppUrl,
      isExternal: true,
    },
  ];

  return (
    <div className="atencion-info-mobile">
      {cards.map((card, index) => {
        const href = card.getHref(card.dynamicValue);
        const cardContent = (
          <>
            <div className="atencion-card-left">
              <img
                src={card.icon}
                className="atencion-card-icon"
                alt={card.staticText}
                width="24"
                height="24"
              />
              <span className="atencion-card-static-text">{card.staticText}</span>
            </div>
            <div className="atencion-card-right">
              <span className="atencion-card-dynamic-text">{card.dynamicValue}</span>
              <FiChevronRight className="atencion-card-chevron" size={20} />
            </div>
          </>
        );

        return (
          <div key={index} className="atencion-card-mobile">
            <a
              href={href}
              {...(card.isExternal && {
                target: "_blank",
                rel: "noopener noreferrer",
              })}
              className="atencion-card-link"
            >
              {cardContent}
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default AtencionInfoMobile;
